/* ==========================================================================
   NOXA — Tiroir panier enrichi (livraison gratuite · minuterie · quantités)
   Intercepte les évènements panier en phase de CAPTURE et stoppe la propagation
   pour neutraliser l'ancien gestionnaire de noxa.js sans le modifier.
   ========================================================================== */
(function () {
  'use strict';

  function drawer() { return document.getElementById('NoxaCartDrawer'); }

  function cfg(key, def) {
    var d = drawer();
    if (!d) return def;
    var v = d.getAttribute('data-' + key);
    return (v === null || v === '') ? def : v;
  }
  function isTrue(v) { return v === 'true' || v === true; }

  function money(cents) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: cfg('currency', 'EUR') }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function renderShipping(d, cart) {
    var box = d.querySelector('[data-cart-ship]');
    if (!box) return;
    var threshold = parseInt(cfg('threshold', '0'), 10) || 0;
    if (!isTrue(cfg('free-enabled', 'false')) || threshold <= 0 || cart.item_count === 0) { box.hidden = true; return; }
    box.hidden = false;
    var total = cart.total_price;
    var txt = box.querySelector('[data-cart-ship-txt]');
    var fill = box.querySelector('[data-cart-ship-fill]');
    if (total >= threshold) {
      if (txt) txt.innerHTML = cfg('free-done', '');
      if (fill) fill.style.width = '100%';
    } else {
      if (txt) txt.innerHTML = cfg('free-text', '').replace('{amount}', '<b>' + money(threshold - total) + '</b>');
      if (fill) fill.style.width = Math.max(4, Math.round(total / threshold * 100)) + '%';
    }
  }

  var timerInt = null;
  function renderTimer(d, cart) {
    var box = d.querySelector('[data-cart-timer]');
    if (!box) return;
    if (!isTrue(cfg('timer-enabled', 'false')) || cart.item_count === 0) {
      box.hidden = true;
      if (timerInt) { clearInterval(timerInt); timerInt = null; }
      return;
    }
    box.hidden = false;
    var mins = parseInt(cfg('timer-min', '10'), 10) || 10;
    var start = parseInt(sessionStorage.getItem('noxaCartTimerStart'), 10);
    if (!start) { start = Date.now(); sessionStorage.setItem('noxaCartTimerStart', start); }
    var tx = box.querySelector('[data-cart-timer-tx]');
    function tick() {
      var left = mins * 60 - Math.floor((Date.now() - start) / 1000);
      if (left < 0) left = 0;
      var m = Math.floor(left / 60);
      var s = left % 60;
      var str = m + ':' + (s < 10 ? '0' + s : s);
      if (tx) tx.innerHTML = cfg('timer-text', '').replace('{time}', '<b>' + str + '</b>');
      if (left <= 0 && timerInt) { clearInterval(timerInt); timerInt = null; }
    }
    if (timerInt) clearInterval(timerInt);
    tick();
    timerInt = setInterval(tick, 1000);
  }

  function renderCart(cart) {
    var d = drawer();
    if (!cart || !d) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var titleEl = d.querySelector('[data-cart-title]');
    if (titleEl) titleEl.textContent = cfg('title', 'Warenkorb') + ' (' + cart.item_count + ')';

    var content = d.querySelector('#NoxaCartContent');
    var foot = d.querySelector('[data-cart-foot]');
    if (!content) return;

    if (cart.item_count === 0) {
      content.innerHTML = '<p class="noxa-cart-drawer__empty">' + (content.dataset.empty || 'Dein Warenkorb ist leer.') + '</p>';
      if (foot) foot.hidden = true;
      renderShipping(d, cart);
      renderTimer(d, cart);
      return;
    }

    var stockOn = isTrue(cfg('stock-enabled', 'false'));
    var stockTxt = cfg('stock-text', '');
    var html = '';
    cart.items.forEach(function (it, i) {
      var line = i + 1;
      var sub = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      html += '<div class="noxa-ci">' +
        (it.image ? '<img class="noxa-ci__img" src="' + it.image + '" alt="" width="64" height="64">' : '<span class="noxa-ci__img"></span>') +
        '<div class="noxa-ci__meta">' +
          '<div class="noxa-ci__nm">' + it.product_title + '</div>' +
          (sub ? '<div class="noxa-ci__sb">' + sub + '</div>' : '') +
          '<div class="noxa-ci__pr">' + money(it.final_line_price) + '</div>' +
          '<div class="noxa-ci__qty">' +
            '<button type="button" data-qty-down data-line="' + line + '" aria-label="-">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-qty-up data-line="' + line + '" aria-label="+">+</button>' +
          '</div>' +
          (stockOn ? '<div class="noxa-ci__stock"><span class="noxa-ci__dot"></span>' + stockTxt + '</div>' : '') +
        '</div>' +
      '</div>';
    });
    content.innerHTML = html;

    if (foot) {
      foot.hidden = false;
      var totEl = foot.querySelector('[data-cart-total]');
      if (totEl) totEl.textContent = money(cart.total_price);
      var subLab = foot.querySelector('[data-cart-subtotal-label]');
      if (subLab) subLab.textContent = cfg('subtotal-label', 'Zwischensumme');
      var co = foot.querySelector('[data-cart-checkout]');
      if (co) co.textContent = cfg('checkout-label', 'Zur Kasse') + ' — ' + money(cart.total_price);
      var t1 = foot.querySelector('[data-cart-trust1]'); if (t1) t1.textContent = cfg('trust1', '');
      var t2 = foot.querySelector('[data-cart-trust2]'); if (t2) t2.textContent = cfg('trust2', '');
    }

    renderShipping(d, cart);
    renderTimer(d, cart);
  }

  function changeLine(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function openCart() {
    var d = drawer();
    if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
    fetchCart().then(renderCart);
  }
  function closeCart() {
    var d = drawer();
    if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  }

  // --- Interception en phase de CAPTURE (neutralise l'ancien noxa.js) ---
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); e.stopImmediatePropagation(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); e.stopImmediatePropagation(); closeCart(); return; }
    var down = e.target.closest('[data-qty-down]');
    if (down) { e.preventDefault(); e.stopImmediatePropagation(); changeLine(parseInt(down.getAttribute('data-line'), 10), Math.max(0, parseInt(down.nextElementSibling.textContent, 10) - 1)); return; }
    var up = e.target.closest('[data-qty-up]');
    if (up) { e.preventDefault(); e.stopImmediatePropagation(); changeLine(parseInt(up.getAttribute('data-line'), 10), parseInt(up.previousElementSibling.textContent, 10) + 1); return; }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('disabled', 'disabled');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) { renderCart(cart); openCart(); })
      .catch(function () {})
      .finally(function () { if (btn) btn.removeAttribute('disabled'); });
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  document.addEventListener('DOMContentLoaded', function () { fetchCart().then(renderCart); });
})();
